import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

import favicon from "assets/icons/favicon.png";
import { Button, ModalRedirect } from "components";

import { Constants } from "appConstants";
import { HomeHero } from "assets/images";
import { SectionHelper } from "helpers";
import { useIsMobile } from "hooks/useIsMobile";
import { useEffect, useState } from "react";
import { ExternalAuthService } from "services/externalAuth";
import "./styles.scss";

export default function Home() {
	const location = useLocation();
	const extAuthService = new ExternalAuthService();
	const isMobile = useIsMobile();

	const [redirectOpen, setRedirectOpen] = useState<boolean>(false);

	const handleRedirect = () => {
		setRedirectOpen(true);
		setTimeout(() => {
			setRedirectOpen(false);
			extAuthService.loginB2C();
		}, 1000);
	};

	useEffect(() => {
		setTimeout(() => {
			if (location.hash) {
				const idSection = SectionHelper.splitHash(location.hash);
				SectionHelper.goToSection(idSection, isMobile ? 64 : 96);
			}
		}, 200);
	}, [location]);

	return (
		<>
			<Helmet>
				<title>{`${process.env.REACT_APP_TITLE} - Página inicial`}</title>
				<link rel="shortcut icon" href={favicon} type="image/x-icon" />
				<link rel="icon" href={favicon} type="image/x-icon" />
			</Helmet>
			<div className="container-common">
				<div className="flex flex-col mx-auto px-6 mb-8 max-w-[85rem] max-sm:items-start">
					<div className="max-[688px]:max-w-[310px]">
						<h1 className="max-w-[52rem] text-3xl sm:text-7xl font-light sm:font-extralight mt-[152px]">
							Sistema de gestão para veículos isentos
						</h1>
						<p className="text-lg mt-2 sm:mt-4 max-sm:text-neutral-low-400">
							Solicite a isenção do seu veículo em rodovias sob a concessão da Motiva.
						</p>
					</div>
					<div>
						<Button className="cursor-pointer flex items-center mt-8 w-[220px] sm:w-[423px]" onClick={handleRedirect}>
							Acessar a plataforma
						</Button>
					</div>
				</div>
				<div className="h-[15rem] md:h-[34rem] w-screen">
					<img src={HomeHero} alt="Portal de Isentos" className="w-full h-full object-cover object-center" />
				</div>
			</div>
			<ModalRedirect isOpen={redirectOpen} text={Constants.textRedirectLogin} />
		</>
	);
}
